module.exports = __webpack_public_path__ + "img/icon-nav3.4c1d3de9.svg";